import { Input } from "../../../atom/Input";
import React from "react";
import { useTranslation } from "react-i18next";
import { EditInformationModalState } from "./EditAddressModal";

interface EditInformationModalContentProps extends EditInformationModalState {
  setInformation: React.Dispatch<React.SetStateAction<EditInformationModalState>>;
}

export const EditInformationModalContent: React.FC<EditInformationModalContentProps> = ({
  first_name,
  last_name,
  phone_number,
  street,
  postalCode,
  city,
  apartmentNumber,
  blockNumber,
  setInformation,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <p className="text-[18px] font-light leading-[22.68px] text-gray-550">{t("First Name")}</p>
        <Input
          id="first_name"
          type="text"
          value={first_name}
          onChange={(e) => setInformation((prev) => ({ ...prev, first_name: e.target.value }))}
        />
      </div>
      <div className="flex items-center justify-between">
        <p className="text-[18px] font-light leading-[22.68px] text-gray-550">{t("Last Name")}</p>
        <Input
          id="last_name"
          type="text"
          value={last_name}
          onChange={(e) => setInformation((prev) => ({ ...prev, last_name: e.target.value }))}
        />
      </div>
      <div className="flex items-center justify-between">
        <p className="text-[18px] font-light leading-[22.68px] text-gray-550">
          {t("Phone Number")}
        </p>
        <Input
          id="phone_number"
          type="text"
          value={phone_number}
          onChange={(e) => setInformation((prev) => ({ ...prev, phone_number: e.target.value }))}
        />
      </div>
      <div className="flex items-center justify-between">
        <p className="text-[18px] font-light leading-[22.68px] text-gray-550">
          {t("Street (if applicable)")}
        </p>
        <Input
          id="street"
          type="text"
          value={street}
          onChange={(e) => setInformation((prev) => ({ ...prev, street: e.target.value }))}
        />
      </div>
      <div className="flex items-center justify-between">
        <p className="text-[18px] font-light leading-[22.68px] text-gray-550">
          {t("Block number")}
        </p>
        <Input
          id="block_number"
          type="text"
          value={blockNumber as string}
          onChange={(e) => setInformation((prev) => ({ ...prev, blockNumber: e.target.value }))}
          inputClassName="max-w-[120px]"
        />
      </div>
      <div className="flex items-center justify-between">
        <p className="text-[18px] font-light leading-[22.68px] text-gray-550">
          {t("Apartment number (if applicable)")}
        </p>
        <Input
          id="apartment_number"
          type="text"
          value={apartmentNumber as string}
          onChange={(e) => setInformation((prev) => ({ ...prev, apartmentNumber: e.target.value }))}
          inputClassName="max-w-[120px]"
        />
      </div>
      <div className="flex items-center justify-between">
        <p className="text-[18px] font-light leading-[22.68px] text-gray-550">{t("Postal code")}</p>
        <Input
          id="postal_code"
          type="text"
          value={postalCode as string}
          onChange={(e) => setInformation((prev) => ({ ...prev, postalCode: e.target.value }))}
          inputClassName="max-w-[120px]"
        />
      </div>
      <div className="flex items-center justify-between">
        <p className="text-[18px] font-light leading-[22.68px] text-gray-550">{t("City")}</p>
        <Input
          id="city"
          type="text"
          value={city}
          onChange={(e) => setInformation((prev) => ({ ...prev, city: e.target.value }))}
        />
      </div>
    </div>
  );
};
